import React from 'react';
import { Col, Row } from 'antd';
import { getChartData } from '../utils';
import { backlinksOverviewSections } from '../settings';
import TableColumnWithTooltip from '../../components/shared/TableColumnWithTooltip/TableColumnWithTooltip';
import BacklinksOverviewBox from './BacklinksOverviewBox';
import { BacklinksOverviewData } from '../types';

type Props = {
    overview: BacklinksOverviewData;
    displayOrder: string[];
    showChart: boolean;
};

export default function BacklinksOverview({ overview, displayOrder, showChart }: Props) {
    return (
        <Row
            gutter={20}
            className="backlinks-overview-wrapper"
        >
            {displayOrder.map((section) => (
                <Col
                    className="overview-box"
                    key={backlinksOverviewSections[section].key}
                >
                    <BacklinksOverviewBox
                        resourceType={backlinksOverviewSections[section].key}
                        title={
                            <TableColumnWithTooltip
                                title={backlinksOverviewSections[section].title}
                                tooltip={backlinksOverviewSections[section].tooltip}
                                noFill
                            />
                        }
                        // value={getMostRecentData(overview, backlinksOverviewSections[section].key)}
                        // trend={<Icon {...getTrendProperties(overview, backlinksOverviewSections[section].key)} />}
                        showChart={showChart}
                        //chartData={getVisibleOverviewData(overview, backlinksOverviewSections[section].key)}
                        chartData={getChartData(overview, backlinksOverviewSections[section].key)}
                    />
                </Col>
            ))}
        </Row>
    );
}
